module.exports = __webpack_public_path__ + "579ed82f25edbcf0e5518089ac6d55d0.png";